import { render } from "./ThreeDModelItem.vue?vue&type=template&id=38ac4e32&scoped=true"
import script from "./ThreeDModelItem.vue?vue&type=script&lang=js"
export * from "./ThreeDModelItem.vue?vue&type=script&lang=js"

import "./ThreeDModelItem.vue?vue&type=style&index=0&id=38ac4e32&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ac4e32"]])

export default __exports__